import { Data, showToast } from "../../../../../../features/ui"
import { useProductActions } from "../../../../actions/productActions"
import { linkedProductsKey, parseLinkedProductsKey } from "./utils"

export const useActions = () => {
    const { linkProducts, unlinkProducts } = useProductActions()

    const onUpdateLinkedProducts = () => showToast('La configuración fue actualizada.')

    const submitLinkProducts = async (data: Data) => {
        const { productId_1, productId_2, equivalence } = data
        await linkProducts(productId_1! as string, productId_2! as string, equivalence! as number)
        onUpdateLinkedProducts()
    }

    const submitUnlinkProducts = async (key: string) => {
        linkedProductsKey
        const { productId_1, productId_2 } = parseLinkedProductsKey(key)
        await unlinkProducts(productId_1, productId_2)
        onUpdateLinkedProducts()
    }

    return {
        submitLinkProducts,
        submitUnlinkProducts
    }
}
